import {
  TmElement,
  border2,
  rem,
  spacing,
  reset,
  token,
} from '@thiememeulenhoff/lit-sdk';
import { css, html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { tagName } from '../../../helpers';

const tag = tagName('header-item');

@customElement(tag)
export class HeaderItemComponent extends TmElement {
  static override styles = [
    reset.a,
    css`
      :host {
        align-items: center;
        block-size: 100%;
        cursor: pointer;
        display: flex;
        padding: ${spacing(0, 100)};
      }

      :host(:hover) {
        background: ${token('background-quaternary')};
      }

      :host([active]) {
        background: ${token('tone-neutral-background-hover')};
        border-block-end: ${border2(3, 'albert-header-item-border-active')};
        border-block-start: ${rem(3)} solid hsla(0, 0%, 0%, 0);
      }
    `,
  ];

  @property({ type: String, reflect: true })
  href?: string;

  @property({ type: Boolean, reflect: true })
  active = false;

  override render() {
    return html`<a href="${this.href ?? nothing}"><slot></slot></a>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'a-header-item': HeaderItemComponent;
  }
}
